import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Subsection from '@/components/entity-onboarding-details/components/subsection';
import useRiskSignalGroupText from '@/components/entity-onboarding-details/hooks/use-risk-signal-group-text';
import useDocumentText from '@/entity/hooks/use-document-text';
import type { RiskSignalSection } from '../../utils/group-risk-signals';
import Loading from './components/loading';
import RiskSignalItem from './components/risk-signal-item';

// Collapsed, each group keeps its most severe signals, so a long group can't hide the ones after it.
const COLLAPSED_SIGNALS_PER_GROUP = 5;
// Collapsing only pays off when it hides a few signals.
const MIN_HIDDEN_SIGNAL_COUNT = 3;
type OnboardingRiskSignalsProps = {
  isLoading: boolean;
  riskSignals: RiskSignalSection[];
};
const OnboardingRiskSignals = t0 => {
  const $ = _c(10);
  const {
    isLoading,
    riskSignals
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.riskSignals"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const riskSignalGroupT = useRiskSignalGroupText();
  const documentT = useDocumentText();
  const [isExpanded, setIsExpanded] = useState(false);
  let t2;
  let t3;
  if ($[1] !== documentT || $[2] !== isExpanded || $[3] !== isLoading || $[4] !== riskSignalGroupT || $[5] !== riskSignals || $[6] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const signalCount = riskSignals.reduce(_temp, 0);
      const hiddenCount = riskSignals.reduce(_temp2, 0);
      const isCollapsible = hiddenCount >= MIN_HIDDEN_SIGNAL_COUNT;
      const isCollapsed = isCollapsible && !isExpanded;
      if (isLoading) {
        let t4;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <Subsection><Loading /></Subsection>;
          $[9] = t4;
        } else {
          t4 = $[9];
        }
        t3 = t4;
        break bb0;
      }
      t2 = <Subsection>{riskSignals.length > 0 ? <div className="flex flex-col gap-4">{riskSignals.map(t4 => {
            const {
              key,
              group,
              documentKind,
              signals: signals_1
            } = t4;
            const groupLabel = riskSignalGroupT?.(group) || t(_temp3);
            return <div key={key}><h4 className="mb-2 text-label-2">{documentKind ? t(_temp4, {
                  group: groupLabel,
                  document: documentT(documentKind)
                }) : groupLabel}{" "}({signals_1.length})</h4><div className="flex flex-col gap-1">{(isCollapsed ? signals_1.slice(0, COLLAPSED_SIGNALS_PER_GROUP) : signals_1).map(_temp5)}</div></div>;
          })}{isCollapsible && <LinkButton className="self-start" onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? t(_temp6) : t(_temp7, {
              count: signalCount
            })}</LinkButton>}</div> : <span className="text-body-2 text-tertiary">{t(_temp8)}</span>}</Subsection>;
    }
    $[1] = documentT;
    $[2] = isExpanded;
    $[3] = isLoading;
    $[4] = riskSignalGroupT;
    $[5] = riskSignals;
    $[6] = t;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
};
export default OnboardingRiskSignals;
function _temp(count, t0) {
  const {
    signals
  } = t0;
  return count + signals.length;
}
function _temp2(count_0, t0) {
  const {
    signals: signals_0
  } = t0;
  return count_0 + Math.max(0, signals_0.length - COLLAPSED_SIGNALS_PER_GROUP);
}
function _temp3($) {
  return $.group.other;
}
function _temp4($_0) {
  return $_0.groupWithDocument;
}
function _temp5(signal) {
  return <RiskSignalItem key={signal.id} riskSignal={signal} />;
}
function _temp6($_1) {
  return $_1.showLess;
}
function _temp7($_2) {
  return $_2.showAll;
}
function _temp8($_3) {
  return $_3.noRiskSignals;
}